import { get } from 'local-storage'
import config from '@config'
interface IRequestInit {
    url: string,
    method: string,
    body?: any
}

enum HttpCodeEnum {
    Ok = 200,
    Created = 201,
    NoContent = 204,
    Unauthorized = 401
}

const successList = new Set([HttpCodeEnum.Ok, HttpCodeEnum.Created, HttpCodeEnum.NoContent])

export const fetchHelper = async ({ url, method, body }: IRequestInit): Promise<any> => {
    let token = get<string>(`token`)

    const responseInit: any = {
        method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    }

    if (token) {
        responseInit.headers[`Authorization`] = `Bearer ${token}`
    }

    if (body) {
        responseInit.body = JSON.stringify(body)
    }

    responseInit

    return fetch(`${config.API_BASEURL}${url}`, responseInit)
        .then(response => {
            // Error response
            if (!successList.has(response.status)) {
                return response.json()
                    .then(body => {
                        throw new Error(body.message)
                    })
            }

            // Unauthorized
            if (response.status === HttpCodeEnum.Unauthorized) {
                throw new Error("unauthorized")
            }

            // NoContent
            if (response.status === HttpCodeEnum.NoContent) {
                return
            }

            return response.text()
                .then(res => {
                    if (res) {
                        return JSON.parse(res)
                    }
                })
        })
        .catch(Promise.reject.bind(Promise))
}